<template>
  <div>
    <titleAgency/>
    <filterAgency class="my-2" />
    <tableAgency/>
  </div>
</template>

<script>
import titleAgency from '@/components/_manageagency/_overview/title.vue'
import filterAgency from '@/components/_manageagency/_overview/filter.vue'
import tableAgency from '@/components/_manageagency/_overview/table.vue'
export default {
  components: {
    titleAgency, filterAgency, tableAgency
  }
}
</script>

<style scoped>
</style>
